import { ReactNode } from "react";
import ExclamationIcon from "../../assets/icons/ExclamationIcon";
import { CustomModalProps } from "../../types";
import CustomModal from "./CustomModal";

type ConfirmModalProps<T> = {
  data?: T;
  subTitle?: string;
  submitDisabled?: boolean;
  okLoading?: boolean;
  handleOk: (val?: T) => void;
  children?: ReactNode;
  alertClassName?: string;
  hideAlert?: boolean;
  closable?: boolean;
  modalClassName?: string;
  handleCancel?: () => void;
  icon?: ReactNode;
} & CustomModalProps;

export default function ConfirmModal<T>({
  data,
  title = "Delete This.",
  subTitle = "Are sure to delete this?",
  okText = "Delete",
  okLoading,
  submitDisabled,
  alertClassName = "",
  disableCloseButton,
  okButtonProps,
  handleOk,
  handleClose,
  handleCancel,
  children,
  hideAlert,
  closable = false,
  modalClassName,
  icon,
  width,
  ...rest
}: ConfirmModalProps<T>) {
  return (
    <CustomModal
      width={width || 400}
      className={`confirm-modal ${modalClassName}`}
      handleClose={handleClose}
      closable={closable}
      okText={okText}
      onOk={() => handleOk(data)}
      title={undefined}
      okButtonProps={{
        loading: okLoading,
        className: "modal-button",
        ...okButtonProps,
      }}
      cancelButtonProps={{
        className: "normal-dark-button modal-button",
        onClick: handleCancel || handleClose,
      }}
      {...rest}
    >
      {!hideAlert ? (
        <div className={`flex gap-4 ${alertClassName}`}>
          {icon && <ExclamationIcon />}
          <div>
            <h4 className="text-header text-2xl font-semibold leading-normal relative -top-[2.5px]">
              {title}
            </h4>

            <p className="text-body-text text-base font-medium leading-normal mt-1">
              {subTitle}
            </p>
          </div>
        </div>
      ) : null}

      {children}
    </CustomModal>
  );
}
